import { LogoutIcon, PencilAltIcon, UserIcon } from '@heroicons/react/outline';

export const MENU_LIST = [
  {
    id: 1,
    label: '마이페이지',
    route: '/account',
    icon: <UserIcon className="w-5 mr-3" />,
  },
  {
    id: 2,
    label: '피드백보내기',
    route: '/feadback',
    icon: <PencilAltIcon className="w-5 mr-3" />,
  },
  {
    id: 3,
    label: '로그아웃',
    route: '/logout',
    icon: <LogoutIcon className="w-5 mr-3" />,
  },
];
